module.exports = __webpack_public_path__ + "error.svg";


//////////////////
// WEBPACK FOOTER
// ./~/blueimp-gallery/img/error.svg
// module id = 1141
// module chunks = 14